import React from 'react'
import Analytics from './Analytics'
import Cards from './Cards'
import Footer from './Footer'
import Hero from './Hero'
import Navbar from './Navbar'
import Newsletter from './Newsletter'
import './Layout.css'

function Layout() {
  return (
    <div>
      <div className='layout-container'>
      <Navbar />
      <Hero />
      <Analytics />
      
      {/*  
      <Newsletter />
      <Cards />
      */}
      <Footer />
      </div>

    </div>
  )
}

export default Layout